import { lazy } from 'react';

const CouponsList = lazy(() =>  import('../pages/Coupons/List'));
// const CouponsDetail = lazy(() =>  import('../pages/Coupons/Detail'));

export default [{
    path: "/coupons",
    element: CouponsList,
    analytics: { name: ["Coupon"]}
}]
